export const EMPLOYER_BRANDING_META_DESCRIPTION =
  "Employer brand analysis and media listening for HR and employer branding teams - measure perception across SEE with Perceptica's analysts.";
